import React, { useState } from 'react'
import { FaEdit, FaEye, FaTimes, FaUsers } from 'react-icons/fa';
import SlidingDiv from '../../../components/SlidingDiv';
import { useOutletContext } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useAuth } from '../../../context/auth-context';
import { customStyles } from '../../../styles';
import SupplierStatement from '../suppliers/SupplierStatement';
import CustomerData from '../customers/customerStatement';
import axios from 'axios';
import { toast } from 'react-toastify';
import { rootUrl } from '../../../helpers';

export default function Clients() {

    
     const [searchQuery, setSearchQuery] = useState("");
     const [isSlidingDivOpen, setIsSlidingDivOpen] = useState(false);
      const [title, setTitle] = useState('');
      const [output, setOutput] = useState('');
      const [selectedType, setSelectedType] = useState("");
      const [showEditModal, setShowEditModal] = useState(false);
      const [editForm, setEditForm] = useState({
        id: "",
        name: "",
        nrc: "",
        phoneNumber: "",
        email: "",
        address: "",
      });
      const [isSaving, setIsSaving] = useState(false);

    const {allData, setAllData} = useOutletContext();
    const auth = useAuth();

    const toggleSlidingDiv = () => setIsSlidingDivOpen(!isSlidingDivOpen);

    const isCustomer = (type) => type != 1 && type != 2;

    const openEditCustomer = (row) => {
      setEditForm({
        id: row.id,
        name: row.name || "",
        nrc: row.nrc || row.person || "",
        phoneNumber: row.pnumber || "",
        email: row.email || "",
        address: row.address || "",
      });
      setShowEditModal(true);
    };

    const closeEditModal = () => {
      setShowEditModal(false);
      setEditForm({
        id: "",
        name: "",
        nrc: "",
        phoneNumber: "",
        email: "",
        address: "",
      });
    };

    const handleEditChange = (e) => {
      const { name, value } = e.target;
      setEditForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleEditSubmit = async (e) => {
      e.preventDefault();
      if (!editForm.name || !editForm.phoneNumber || !editForm.email || !editForm.address || !editForm.nrc) {
        toast.error("Please fill in name, NRC, phone number, email and address");
        return;
      }

      setIsSaving(true);
      try {
        const response = await axios.post(rootUrl("/updateCustomer"), {
          uid: auth.user.id,
          id: editForm.id,
          name: editForm.name,
          nrc: editForm.nrc,
          phoneNumber: editForm.phoneNumber,
          email: editForm.email,
          address: editForm.address,
        });

        if (response.data.status === 200) {
          toast.success("Customer updated successfully");
          setAllData((prevData) => ({
            ...prevData,
            suppliers: response.data.data,
          }));
          closeEditModal();
        } else {
          toast.info(response.data.msg || "Unable to update customer");
        }
      } catch (error) {
        toast.error(error?.message || "Failed to update customer");
      } finally {
        setIsSaving(false);
      }
    };


    function viewSupp(id, type, name){

        toggleSlidingDiv()
    
        if(type !=3){
          setTitle('Supplier Statement')
          setOutput(<SupplierStatement id={id} name={name} />)
        }else{
            setTitle('Supplier Statement')
            setOutput(<CustomerData id={id} name={name} />) 
        }
    
      }
   const columns = [
      {
        name: "Sn",
        selector: (row, index) => index + 1,
        width: "50px",
        center: true,
      },
      {
        name: "Names",
        selector: (row) =>`${row.name} ${" "} ${row.person !== null?row.person:''}`,
        sortable: true,
      },
      {
        name: "Contact",
        selector: (row) => row.pnumber,
      },
      {
        name: "Email",
        selector: (row) => row.email,
      },
      {
        name: "Type",
        selector: (row) => row.type==1?'Supplier':row.type==2?'Employee':'Customer',
      },
      {
        name: "Actions",
        cell: (row) => (
          <div className="flex items-center justify-center gap-2">
            <button
              onClick={() => viewSupp(row.id, row.type, row.name)}
              className="bg-blue-950 text-white px-2 py-2 rounded-lg text-lg"
              title="View statement"
            >
              <FaEye />
            </button>
            {isCustomer(row.type) && (
              <button
                onClick={() => openEditCustomer(row)}
                className="bg-amber-600 text-white px-2 py-2 rounded-lg text-lg"
                title="Edit customer"
              >
                <FaEdit />
              </button>
            )}
          </div>
        ),
        button: true,
        center: true,
      },
    ];
    
      const filteredData = allData.suppliers.filter(supplier => {
        const matchesSearch = supplier.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesType = selectedType === "" || 
          (selectedType == "1" && supplier.type == 1) ||
          (selectedType == "2" && supplier.type == 2) ||
          (selectedType == "3" && supplier.type != 1 && supplier.type != 2);
        
        return matchesSearch && matchesType;
      });
  
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center gap-4">
          <div className="bg-white/20 rounded-xl p-3">
            <FaUsers className="text-2xl" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">Clients</h1>
            <p className="text-blue-100 text-sm mt-1">
              Combined view of suppliers, employees, and customers.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full flex flex-col bg-white min-h-[400px] rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100">
        {/* Clients Table */}
        <div id="supTable">
          {/* Filters */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
            <input
              type="text"
              placeholder="Search by name, contact or email..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="p-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <select
              value={selectedType}
              onChange={e => setSelectedType(e.target.value)}
              className="p-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Types</option>
              <option value="1">Supplier</option>
              <option value="2">Employee</option>
              <option value="3">Customer</option>
            </select>
          </div>

          <p className="text-xs text-gray-500 mb-2">
            A list of all clients below. Showing{" "}
              <span className="font-semibold text-gray-700">
                {filteredData.length}
              </span>{" "}
              record{filteredData.length === 1 ? "" : "s"}.
          </p>

          <div className="rounded-xl border border-gray-100 bg-white overflow-hidden">
            <div className="overflow-x-auto">
              <DataTable
                title=""
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                striped
                responsive
                customStyles={customStyles}
              />
            </div>
          </div>
        </div>

        <SlidingDiv
          isOpen={isSlidingDivOpen}
          onClose={toggleSlidingDiv}
          title={title}
          children={output}
        />

        {showEditModal && (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
            <form
              onSubmit={handleEditSubmit}
              className="bg-white rounded-2xl p-4 md:p-5 w-full max-w-xl shadow-xl overflow-y-auto"
            >
              <div className="flex justify-between items-center mb-3 border-b pb-3">
                <h2 className="text-lg md:text-xl font-semibold text-gray-800">Edit Customer</h2>
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200"
                >
                  <FaTimes size={14} />
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="name"
                    value={editForm.name}
                    onChange={handleEditChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    NRC <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="nrc"
                    value={editForm.nrc}
                    onChange={handleEditChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="phoneNumber"
                    value={editForm.phoneNumber}
                    onChange={handleEditChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="email"
                    type="email"
                    value={editForm.email}
                    onChange={handleEditChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="address"
                    value={editForm.address}
                    onChange={handleEditChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>

              <div className="mt-6 pt-4 border-t border-gray-200 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSaving}
                  className="px-6 py-2.5 bg-gradient-to-r from-blue-950 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all font-medium disabled:opacity-60"
                >
                  {isSaving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
